import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const ViewProjectStatus = () => {
    const { projectId } = useParams();
    const [project, setProject] = useState({});
    const [departments, setDepartments] = useState([]);
    const [contributors, setContributors] = useState([]);
    
    const [users, setUsers] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    

    const statusLabels = {
        0: "UnApproved",
        1: "Approved Level 1",
        2: "Archived"
    };
    // Fetch project details
    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/projects/${projectId}`)
                .then(response => response.json())
                .then(data => setProject(data))
                .catch(error => console.error('Error fetching project details:', error));
        }
    }, [projectId]);

    // Fetch users for the "Reviewed By" dropdown
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/users`)
            .then((response) => response.json())
            .then((data) => setUsers(data))
            .catch((error) => console.error('Error fetching users:', error));
    }, []);

    // Fetch departments for the project
    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/project-departments/${projectId}`)
                .then(response => response.json())
                .then(data => setDepartments(data.departments))
                .catch(error => console.error('Error fetching project departments:', error));
        }
    }, [projectId]);

    // Fetch contributors for the project
    useEffect(() => {
        if (projectId) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/project-contributors/${projectId}`)
                .then(response => response.json())
                .then(data => setContributors(data.contributors))
                .catch(error => console.error('Error fetching project contributors:', error));
        }
    }, [projectId]);

    const handleStatusUpdate = (status) => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/projects/${projectId}/status?status=${status}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => {
                if (response.ok) {
                    return fetch(`${process.env.REACT_APP_API_BASE_URL}/api/projects/${projectId}`); // Fetch updated project details
                } else {
                    return response.text().then(text => { throw new Error(text); });
                }
            })
            .then(response => response.json())
            .then(updatedProject => {
                setProject(updatedProject);
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: `Project status updated to "${statusLabels[status]}" successfully!`,
                    timer: 2000,
                    showConfirmButton: false
                });
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'Failed to update project status: ' + error.message,
                });
            });
    };

    return (
        <div className="container mt-4">
            <h3>Project Details for {projectId}</h3>
            <div className="card mb-3">
                <div className="card-body">
                    <p><strong>TRL Level:</strong> {project.trlLevel}</p>
                    <p><strong>Project ID:</strong> {project.projId}</p>
                    <p><strong>Title:</strong> {project.projTitle}</p>
                    <p><strong>Summary:</strong> {project.projSummary}</p>
                    <p><strong>Lab:</strong> {project.labId}</p>
                    <p><strong>Project Type:</strong> {project.projType}</p>
                    <p><strong>Utilization:</strong> {project.projUtilization}</p>
                    <p><strong>Initial Fund:</strong> {project.projInitialFund}</p>
                    <p><strong>Start Date:</strong> {project.projStartDate}</p>
                    <p><strong>End Date:</strong> {project.projEndDate}</p>
                    <p><strong>Project Status:</strong> {statusLabels[project.status] || "Unknown"}</p>

                </div>
            </div>

            {/* Departments List */}
            <h5>Departments:</h5>
            <ul className="list-group mt-3">
                {Array.isArray(departments) && departments.length > 0 ? (
                    departments.map((dept) => (
                        <li key={dept.deptId} className="list-group-item d-flex justify-content-between align-items-center">
                            {dept.deptId} {dept.deptName}
                        </li>
                    ))
                ) : (
                    <li className="list-group-item">No Departments Found</li>
                )}
            </ul>

            {/* Contributors List */}
            <h5>Contributors:</h5>
            <ul className="list-group mt-3">
                {Array.isArray(contributors) && contributors.length > 0 ? (
                    contributors.map((contributor) => (
                        <li key={contributor.userId} className="list-group-item d-flex justify-content-between align-items-center">
                            {contributor.userId} {contributor.username}
                        </li>
                    ))
                ) : (
                    <li className="list-group-item">No Contributors Found</li>
                )}
            </ul>

            {/* Status Update Buttons */}
            <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 1050 }}>
                <button
                    className="btn btn-success mx-2"
                    onClick={() => handleStatusUpdate('1')}
                >
                    Approve Level 1
                </button>
                <button
                    className="btn btn-danger btn-sm m-1"
                    onClick={() => handleStatusUpdate('2')}
                >
                    Archive
                </button>
                <button
                    className="btn btn-warning btn-sm mx-2"
                    onClick={() => handleStatusUpdate('0')}
                >
                    UnApprove
                </button>
            </div>

            {/* Success/Error Messages */}
            {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
            {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
        

            
        </div>
    );
};

export default ViewProjectStatus;
